import { Decimal } from '@snap-types/types/decimal';

import type { QuantityAwareConfig, QuantityAwareInputs } from '../types';
import { calculateLeadTimeBreakdown } from './breakdown';

/**
 * The whole-week lead time for a quantity. Derived from the same breakdown the
 * UI explains, so the two cannot drift apart.
 */
export function calculateTotalLeadTime(
  quantity: Decimal,
  inputs: QuantityAwareInputs,
  config: QuantityAwareConfig,
): number | null {
  return (
    calculateLeadTimeBreakdown(quantity, inputs, config)?.totalWeeks ?? null
  );
}
